(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/sum.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/sum.js');
"use strict";


const Sum = _ref => {
  let value = _ref.value;
  const animateNumbers = svs.tur.ReactPayfooter.utils.animateNumbers;
  const sumRef = React.useRef(null);
  const currentSum = React.useRef(0);
  React.useEffect(() => {
    if (sumRef.current && currentSum.current) {
      animateNumbers({
        element: sumRef.current,
        from: currentSum.current,
        to: value
      });
      currentSum.current = value;
    }
  }, [value]);
  if (isNaN(parseFloat(value))) return null;
  return React.createElement("div", {
    className: "payfooter-text-sum"
  }, React.createElement("div", {
    className: "payfooter-numbers payfooter-sum",
    ref: sumRef
  }, "Summa: ", svs.utils.format.Currency(Number(value)), " kr"));
};
svs.tur.ReactPayfooter.Sum = Sum;

 })(window);